import { FontConfig } from "../types"

export const BODY_LG_CONFIG: FontConfig = {
  title: "BODY/lg",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 16, tw: "text-[16px]" },
    lineHeight: { px: 22, tw: "leading-[22px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 16, tw: "text-[16px]" },
    lineHeight: { px: 28, tw: "leading-[28px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 20, tw: "text-[20px]" },
    lineHeight: { px: 27, tw: "leading-[27px]" },
  },
}
